import React, { useEffect, useRef, useState } from "react";
import { Gender, useGuideSearch } from "../../../hooks/search/useGuideSearch";
import { Colors } from "../../../module/constant";
import { Guide } from "../../../types/type";

type GuideSearchResultProps = {
  onClickResult?: (guide: Guide) => void;
  genderMode?: Gender;
  autoFocus?: boolean;
  titleOff?: boolean;
};

const GuideSearchTester: React.FC<GuideSearchResultProps> = ({
  onClickResult,
  genderMode = "male",
  autoFocus,
  titleOff,
}) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [, setIsTyping] = useState<boolean>(false);
  const [selectedGender, setSelectedGender] = useState<Gender>(genderMode);
  const inputRef = useRef<HTMLInputElement>(null);

  const { searchResult } = useGuideSearch(
    searchQuery,
    setIsTyping,
    selectedGender
  );

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setIsTyping(true);
  };

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div style={{ padding: "20px" }}>
      {!titleOff && (
        <h1 style={{ fontSize: "2rem", marginBottom: "20px" }}>Search</h1>
      )}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button
          style={{
            backgroundColor:
              selectedGender === "male" ? Colors.ACCENT1 : "gray",
            color: selectedGender === "male" ? Colors.BLACK : Colors.WHITE,
            border: "none",
          }}
          onClick={() => setSelectedGender("male")}
        >
          male
        </button>
        <button
          style={{
            backgroundColor:
              selectedGender === "female" ? Colors.ACCENT1 : "gray",
            color: selectedGender === "female" ? Colors.BLACK : Colors.WHITE,
            border: "none",
          }}
          onClick={() => setSelectedGender("female")}
        >
          female
        </button>
        <button
          style={{
            backgroundColor: selectedGender === "all" ? Colors.ACCENT1 : "gray",
            color: selectedGender === "all" ? Colors.BLACK : Colors.WHITE,
            border: "none",
          }}
          onClick={() => setSelectedGender("all")}
        >
          all
        </button>
      </div>
      <input
        type="text"
        ref={inputRef}
        value={searchQuery}
        onChange={handleInputChange}
        placeholder="Search for songs or artists..."
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "5px",
          border: "1px solid #ccc",
          marginBottom: "20px",
        }}
      />

      <div>
        {searchResult.length > 0 ? (
          searchResult.map((item, index) => (
            <div
              key={item.id}
              style={{ marginBottom: "10px", cursor: "pointer" }}
              onClick={() => {
                if (onClickResult) onClickResult(item);
              }}
            >
              <strong>{item.guideTitle}</strong>
            </div>
          ))
        ) : (
          <p>No results found.</p>
        )}
      </div>
    </div>
  );
};

export default GuideSearchTester;
